// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmojiPicker_wrapper__N4j4u","backdrop":"EmojiPicker_backdrop__1q7Fr","picker":"EmojiPicker_picker__1pc1e","value":"EmojiPicker_value__2F1th"};